import {type GetterTree} from 'vuex';

const getters: GetterTree<ICustomerState, RootState> = {
    isAdmin(state)
    {
        return state.isAdmin;
    },

    invoicingParty(state)
    {
        return state.invoicingParty;
    },

    invoicingPartyNoPlaceholder(state)
    {
        return state.invoicingParty.filter((party) => party.value);
    },

    products(state)
    {
        return state.products;
    },

    productSelectOptions(state): SelectOption[]
    {
        return state.products.map((product: ICustomerProductEntry) => ({
            value: product.id,
            label: product.matchcode,
        }));
    },

    fetched(state)
    {
        return state.fetched;
    },

};

export default getters;